import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const RefundPolicy = () => (
  <Box sx={{ py: 8, bgcolor: '#f9fafb', minHeight: '100vh' }}>
    <Container maxWidth="md">
      <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
        Refund Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: April 23, 2026
      </Typography>

      <Divider sx={{ mb: 4 }} />

      <Section title="How WordExPress charges you">
        WordExPress uses a pay-on-completion model. You are only charged when your theme
        has been successfully generated and is available for download. If generation fails,
        you are not charged and you receive up to 3 free retry attempts at no cost.
      </Section>

      <Section title="When a refund applies">
        Because you only pay for a theme that has already been successfully delivered,
        refund situations are rare. However, we will issue a full refund in the following
        circumstances:
        <ul>
          <li>The delivered theme cannot be activated in a standard WordPress installation due to a code error we introduced.</li>
          <li>The theme you received is materially different from what was described (e.g., wrong industry, completely missing pages you selected).</li>
          <li>You were charged in error (duplicate payment, billing system failure).</li>
        </ul>
      </Section>

      <Section title="How to request a refund">
        Contact us at <strong>support@wordexpress.com</strong> within <strong>7 days</strong> of
        purchase with:
        <ul>
          <li>Your account email address</li>
          <li>The project/order ID (visible on your Projects page)</li>
          <li>A brief description of the issue</li>
        </ul>
        We aim to respond within 1 business day and to resolve all refund requests within 5
        business days of receiving the required information.
      </Section>

      <Section title="Refunds we cannot provide">
        <ul>
          <li>Requests made more than 7 days after the charge date.</li>
          <li>Themes that were successfully delivered but where you changed your mind about the design, industry, or scope after the fact. (We encourage you to review your selections before generating.)</li>
          <li>Studio Pack credits that have already been used to generate themes.</li>
          <li>Partial refunds on the Studio Pack — if none of the 3 credits have been used, a full refund is available within 7 days. Once any credit is redeemed, refunds are limited to unused credits on a pro-rata basis.</li>
        </ul>
      </Section>

      <Section title="Chargebacks">
        If you initiate a chargeback without contacting us first, we reserve the right to
        suspend your account while the dispute is investigated. We prefer to resolve issues
        directly and will cooperate fully with your bank or card issuer.
      </Section>

      <Section title="Contact">
        For any billing questions, email us at <strong>support@wordexpress.com</strong>.
        We are a small team and we read every message.
      </Section>
    </Container>
  </Box>
);

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h5" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary" component="div" sx={{ lineHeight: 1.8 }}>
      {children}
    </Typography>
  </Box>
);

export default RefundPolicy;
